import { Card, Grid, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { oneSystemAction } from './SystemAction';
import FormSystem from './components/FormSystem';

const SystemView = () => {
  const dispatch = Redux.useDispatch();

  const systemStore = Redux.useSelector((state) => state.system);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      setLoading(true);
      await oneSystemAction(dispatch);
      setLoading(false);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const info = (
    <Grid item md={7}>
      <Grid container spacing={1}>
        <Grid item md={12}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Nombre de la aplicación
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="initial">
              {systemStore.activo?.name}
            </Typography>
          </Card>
        </Grid>

        <Grid item md={12}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Url
            </Typography>
            <Typography variant="body1" fontWeight="bold" color="initial">
              {systemStore.activo?.url}
            </Typography>
          </Card>
        </Grid>

        <Grid item md={12}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Link de Descarga
            </Typography>
            <Typography variant="body1" fontWeight="bold" color="initial">
              {systemStore.activo?.urlDownload}
            </Typography>
          </Card>
        </Grid>

        <Grid item md={12}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Descripción
            </Typography>
            <Typography variant="body1" fontWeight="bold" color="initial">
              {systemStore.activo?.desc}
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );

  const versions = (
    <Grid item md={5}>
      <Grid container spacing={1}>
        <Grid item md={6}>
          <Card sx={{ p: 2, backgroundColor: blue[100] }}>
            <Typography variant="body1" color="initial">
              Version Actual
            </Typography>
            <Typography variant="h5" fontWeight="bold" color="initial">
              {systemStore.activo?.appVersion}
            </Typography>
          </Card>
        </Grid>

        <Grid item md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Version Anterior
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="initial">
              {systemStore.activo?.beforeVersion}
            </Typography>
          </Card>
        </Grid>
        <Grid item md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Actualización forzada
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="initial">
              {systemStore.activo?.forceUpdate ? 'Si' : 'No'}
            </Typography>
          </Card>
        </Grid>
        <Grid item md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Mantenimiento
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="initial">
              {systemStore.activo?.maintenance ? 'Si' : 'No'}
            </Typography>
          </Card>
        </Grid>
        <Grid item md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Version Andriod
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="initial">
              {systemStore.activo?.andriodVersion}
            </Typography>
          </Card>
        </Grid>
        <Grid item md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Version IOS
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="initial">
              {systemStore.activo?.iosVersion}
            </Typography>
          </Card>
        </Grid>
        <Grid item md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Version WEB
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="initial">
              {systemStore.activo?.webVersion}
            </Typography>
          </Card>
        </Grid>
        <Grid item md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="body1" color="initial">
              Version Desktop
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="initial">
              {systemStore.activo?.desktopVersion}
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {loading && !systemStore.activo ? (
          'Cargando...'
        ) : (
          <Grid container spacing={1}>
            <Grid item md={12}>
              <BotonComponent
                click={() => setOpenModalForm(true)}
                blue
                text="EDITAR"
                editIcon
              />
            </Grid>
            {versions}
            {info}
          </Grid>
        )}
      </Grid>
      <ModalComponent
        id="modalFormSystem"
        title="Editar información"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormSystem
          activo={systemStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default SystemView;
